export const tabbedHideSeek = () => {
    const $ = jQuery;
    const $pagerTriggers = $('.tabbed-hide-seek__pager-button');

    $pagerTriggers.click((e) => {
        const $el = $(e.currentTarget);
        const $hideSeek = $el.parents('.tabbed-hide-seek').find('.tabbed-hide-seek-wrapper');
        const targets = $el.attr('aria-controls').split(" ");

        $el.parent().find('.active').removeClass('active');
        $el.addClass('active');
        //hide content
        $hideSeek.find('.content-column').removeAttr('open');
        $hideSeek.find('.media-items-wrapper > div').removeAttr('open');
        $hideSeek.siblings('.video-background-wrapper').removeAttr('open');

        targets.forEach((target) => {
            const $target = $('#' + target);
            $target.attr('open', 1);
            $('.accordion-item-1 .accordion-header', $target).click();
        });
    });
}